import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tabs } from 'antd';
import { FileOutlined, BranchesOutlined, FileDoneOutlined } from '@ant-design/icons';
import './OutputPreview.less';
import { DocumentPreview, TemplateColumnsPreview, ChildSessionsPreview } from '../';
import { useAppStore } from '../../stores';
import { endpoints } from '../../../../config';

const { TabPane } = Tabs;

type Props = {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    style?: React.CSSProperties;
    onLoadComplete?: () => void;
};

const OutputPreview: React.FC<Props> = ({ activeTab, setActiveTab, style, onLoadComplete }) => {
    const { currentTemplateId, sessionId, sessionStore } = useAppStore();
    return (
        <div className="output-preview">
            <Tabs activeKey={activeTab} onChange={key => setActiveTab(key)} animated={false}>
                <TabPane
                    tab={
                        <>
                            <FileOutlined /> File Preview
                        </>
                    }
                    key="file-preview"
                >
                    {sessionStore.processedPackageId && (
                        <DocumentPreview
                            packageId={sessionStore.processedPackageId}
                            packageName={sessionStore.processedPackageId + '.xlsx'}
                            packageUrl={`${endpoints.iotaUrl}data-crafter/package/preview/${sessionId}/${sessionStore.processedPackageId}`}
                            sheetsbar
                            style={style}
                            onLoadComplete={onLoadComplete}
                        />
                    )}
                </TabPane>
                <TabPane
                    tab={
                        <>
                            <BranchesOutlined /> Mapping Rules
                        </>
                    }
                    key="used-rules"
                    disabled={!currentTemplateId}
                >
                    <TemplateColumnsPreview />
                </TabPane>
                {sessionStore.childSessions && sessionStore.childSessions.length > 0 && (
                    <TabPane
                        tab={
                            <>
                                <FileDoneOutlined /> Child Sessions
                            </>
                        }
                        key="child-sessions"
                    >
                        <ChildSessionsPreview
                            childSessions={sessionStore.childSessions}
                            openChildSession={sessionStore.openChildSession}
                            getUserById={sessionStore.getUserById}
                        />
                    </TabPane>
                )}
            </Tabs>
        </div>
    );
};

export default observer(OutputPreview);
